import { createReducer } from '@reduxjs/toolkit'
import { preloadedRootState } from '@ads/front-core/store/rootState'
import { setAdmins, setAdminsReducer } from './setAdminsReducer'

const adminsReducers = createReducer(preloadedRootState.admins, builder => {
  builder.addCase(setAdmins.type, setAdminsReducer)
})

export default adminsReducers
